import { useState, useEffect } from "react";
import "./App.css";
import Card from "./components/Card/Card";
import Search from "./components/Search/Search";
import Header from "./components/SunTimes/Header/Header";
import Footer from "./components/SunTimes/Footer/Footer";
import logo from "./star.png";
import styles from "./App.module.css";
import GoogleAd from "./components/SunTimes/GoogleAd/GoogleAd";
import * as d3 from "d3";

function App() {
  const [data, setData] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [type, setType] = useState("All");

  async function fetchData() {
    fetch(
      "https://graphics.suntimes.com/data-storage/weed/tmp/weed-testing.json"
    )
      .then((response) => response.json())
      .then((data) => setData(data));
  }

  let filterVal = (o) => true;
  if (searchValue) {
    const category = searchValue.split("|");
    if (category[1].trim() === "product") {
      filterVal = (o) => o["PRODUCT NAME"].trim() === category[0].trim();
    }
    if (category[1].trim() === "lic") {
      filterVal = (o) => o["LIC NAME"].trim() === category[0].trim();
    }
    if (category[1].trim() === "strain") {
      filterVal = (o) => {
        return o["STRAIN"].toString().trim() === category[0].toString().trim();
      };
    }
  }
  let typeFilterVal = (o) => true;
  if (type !== "All") {
    typeFilterVal = (o) => o["PRODUCT TYPE"].trim() === type;
  }

  useEffect(() => fetchData(), []);
  useEffect(() => {
    d3.select("#jump-to-top").on("click", () => window.scrollTo(0, 0));
  });
  let page;

  //6/18/2019
  const formatDate = d3.timeFormat("%m/%e/%Y");

  data
    ? (page = (
        <div>
          <button className={styles.JumpBtn} id="jump-to-top">
            To Top
          </button>
          <Header />
          <GoogleAd />
          <div className={styles.StoryHeader}>
            <h1>
              Explore the Illinois cannabis products that failed regulatory
              testing
            </h1>
            <p>
              Search through the 3,115 test results to learn why cannabis
              flower, hydrogen wax, edibles and other products didn't make it to
              the marketplace.
              <br />
              <a href="https://chicago.suntimes.com/22821279/cannabis-test-failures-illinois-legal-weed-marijuana-companies">
                Learn more about the Sun-Times investigation into cannabis
                testing in Illinois.
              </a>
            </p>
          </div>
          <div className={styles.Credit}>
            <p>
              <span>Reporting by</span>{" "}
              <a href="https://chicago.suntimes.com/authors/stephanie-zimmermann">
                Stephanie Zimmermann
              </a>{" "}
              and{" "}
              <a href="https://chicago.suntimes.com/authors/tom-schuba">
                Tom Schuba
              </a>
            </p>
            <p>
              <span>with data analysis by</span>{" "}
              <a href="https://chicago.suntimes.com/authors/jesse-howe">
                Jesse Howe
              </a>{" "}
              and{" "}
              <a href="https://chicago.suntimes.com/authors/andy-boyle">
                Andy Boyle
              </a>
            </p>
            <p>
              <span>Graphic by</span>{" "}
              <a href="https://chicago.suntimes.com/authors/jesse-howe">
                Jesse Howe
              </a>
            </p>
          </div>
          <p className={styles.Date}>December 10, 2021</p>
          <p className={styles.Note}>Note: Potency measured as % by weight</p>
          <Search
            data={data.filter((d) => filterVal(d) && typeFilterVal(d))}
            fn={(value) => setSearchValue(value)}
          />
          <div className="main-content">
            <div className="btn_container">
              <p>Search by product type</p>
              <div className="inner_container">
                <button
                  className={type === "All" ? "Active" : null}
                  onClick={() => setType("All")}
                >
                  All Products
                </button>
                <button
                  className={type === "Flower Lot" ? "Active" : null}
                  onClick={() => setType("Flower Lot")}
                >
                  Flower Lot
                </button>
                <button
                  className={type === "Hydrocarbon Wax" ? "Active" : null}
                  onClick={() => setType("Hydrocarbon Wax")}
                >
                  Hydrocarbon Wax
                </button>
                <button
                  className={type === "Kief" ? "Active" : null}
                  onClick={() => setType("Kief")}
                >
                  Kief
                </button>
                <button
                  className={
                    type === "Liquid Marijuana Infused Edible" ? "Active" : null
                  }
                  onClick={() => setType("Liquid Marijuana Infused Edible")}
                >
                  Liquid Marijuana Infused Edible
                </button>
                <button
                  className={
                    type === "Marijuana Infused Topicals" ? "Active" : null
                  }
                  onClick={() => setType("Marijuana Infused Topicals")}
                >
                  Marijuana Infused Topicals
                </button>
                <button
                  className={type === "Marijuana Mix" ? "Active" : null}
                  onClick={() => setType("Marijuana Mix")}
                >
                  Marijuana Mix
                </button>
                <button
                  className={
                    type === "Solid Marijuana Infused Edible" ? "Active" : null
                  }
                  onClick={() => setType("Solid Marijuana Infused Edible")}
                >
                  Solid Marijuana Infused Edible
                </button>
              </div>
            </div>
            {data
              .filter((d) => filterVal(d) && typeFilterVal(d))
              .sort((a, b) => (formatDate(a) > formatDate(b) ? 1 : -1))
              .map((d) => (
                <Card sample={d} key={d["SAMPLE"] + d["LOT"]} />
              ))}
          </div>
        </div>
      ))
    : (page = (
        <div className={styles.Loading}>
          <div>
            <div>
              <span className={styles.Logo} aria-hidden="true" tabIndex="-1">
                <img src={logo} alt="Logo" />
              </span>
            </div>
            <p>Loading Weed Failure Database...</p>
          </div>
        </div>
      ));
  return <div className="App">{page}</div>;
}

export default App;
